import React, { useEffect, useMemo } from "react";
import Page from "components/Page";
import { Card } from "reactstrap";
import styles from "pages/AccountPreferences/accountpreferences.module.scss";
import RecallReminder from "assets/images/recall_reminder.svg";
import AppointmentReminder from "assets/images/appointment_reminder.svg";
import fiscalIcon from "assets/images/fiscal.svg";
import generalTimesheetSetting from "assets/images/generalTimesheetSetting.svg";
import timesheetSubmissionControl from "assets/images/timesheetSubmissionControl.svg";
import constants from "../../../../constants";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { decodeId, setStorage } from "utils";
import { useSelector } from "react-redux";
import {
  useOfficeById,
  useStaffByUserId,
} from "repositories/office-repository";

const CardsViewAndRedirection = ({ item }) => {
  return (
    <div
      className={styles["card-con"] + " form-wrapper cursor-pointer mt-0"}
      key={item.id}
      onClick={item.onclick}
    >
      <Card
        className={
          styles["account-preference-card"] +
          " d-flex align-items-center flex-row w-100 cursor-pointer"
        }
      >
        <div className={styles["account-preference-logo"]}>
          <img src={item.chatImg} alt="message template icon" />
        </div>
        <div className={styles["account-preference-text"]}>
          {item.accountName}
        </div>
      </Card>
    </div>
  );
};

const TimeLinePrefences = ({ history, t, location }) => {
  const { officeId } = useParams();
  const decodeOfficeId = parseInt(decodeId(officeId));
  const profile = useSelector((state) => state.userProfile.profile);
  const { data: staffDetail } = useStaffByUserId(decodeOfficeId, profile?.id);
  const { data: officeData } = useOfficeById(decodeOfficeId);
  const ownerCheck = useMemo(
    () => profile?.role?.systemRole === constants.systemRoles.accountOwner,
    [profile?.role?.systemRole]
  );
  const redirection = (pathname) => {
    history.push({
      pathname: pathname.replace(":officeId", officeId),
      state: { officeName: location?.state?.officeName },
    });
  };
  const handleReminderClick = (bool) => {
    redirection(constants.routes.appointment.AccountGlobalOfficeReminder);
    setStorage("isRecallReminderPlan", {
      isRecallReminderPlan: bool,
    });
  };

  const handleTimesheetClick = () => {
    redirection(constants.routes.accountOwner.preferences);
  };

  const handleTimesheetSubmissionClick = () => {
    redirection(constants.routes.accountOwner.submissionPreferences);
  };

  const accountList = [
    {
      id: 2,
      chatImg: AppointmentReminder,
      accountName: t("accountPreferences.appointmentReminderPlan"),
      onclick: handleReminderClick.bind(null, false),
    },
    {
      id: 3,
      chatImg: RecallReminder,
      accountName: t("accountPreferences.appointmentRecallPlan"),
      onclick: handleReminderClick.bind(null, true),
    },
  ];

  const timeSheetPrefrencesList = [
    {
      id: 5,
      chatImg: timesheetSubmissionControl,
      accountName: t("accountOwner.timesheetSubmissionControl"),
      onclick: handleTimesheetSubmissionClick,
    },
  ];
  const fiscalList = [];

  const handleFiscalClick = () => {
    redirection(constants.routes.accountOwner.fiscalYear);
  };

  if (ownerCheck) {
    timeSheetPrefrencesList.unshift({
      id: 4,
      chatImg: generalTimesheetSetting,
      accountName: t("accountOwner.generalTimesheetSettings"),
      onclick: handleTimesheetClick,
    });
  }

  if (ownerCheck || staffDetail?.isAdmin) {
    fiscalList.push({
      id: 1,
      chatImg: fiscalIcon,
      accountName: t("accountPreferences.fiscalYearPlan"),
      onclick: handleFiscalClick,
    });
  }

  useEffect(() => {
    setStorage("isRecallReminderPlan", {
      isRecallReminderPlan: false,
    });
  }, []);

  const goBack = () => {
    if (ownerCheck) {
      redirection(constants.routes.accountOwner.officeOptions);
    } else if (staffDetail?.isAdmin) {
      redirection(constants.routes.staff.officeAdmin);
    } else {
      redirection(constants.routes.staff.officeOptions);
    }
  };

  return (
    <Page
      onBack={goBack}
      className={styles["global-main-page"]}
      title={t("accountPreferences.officePreferences")}
    >
      <p className="pms_subtitle">
        {location?.state?.officeName || officeData?.name}
      </p>

      {/* Heading 1 */}

      <p className={styles.card_heading + " margin30 marginBottom30"}>
        {t("accountOwner.timeLineSettings")}
      </p>
      <div className={styles["manage-card-container"] + " d-flex flex-wrap"}>
        {timeSheetPrefrencesList.map((item) => (
          <CardsViewAndRedirection key={item.id} item={item} />
        ))}
      </div>

      {/* Heading 2 */}
      <p className={styles.card_heading + " margin30 marginBottom30"}>
        {t("accountPreferences.patientSchedulingTemplates")}
      </p>
      <div className={styles["manage-card-container"] + " d-flex flex-wrap"}>
        {accountList.map((item) => (
          <CardsViewAndRedirection key={item.id} item={item} />
        ))}
      </div>

      {/* Heading 3 */}
      {(ownerCheck || staffDetail?.isAdmin) && (
        <>
          <p className={styles.card_heading + " " + "margin30 marginBottom30"}>
            {t("accountPreferences.officeConfiguration")}
          </p>
          <div
            className={styles["manage-card-container"] + " d-flex flex-wrap"}
          >
            {fiscalList.map((item) => (
              <CardsViewAndRedirection key={item.id} item={item} />
            ))}
          </div>
        </>
      )}
    </Page>
  );
};

export default withTranslation()(TimeLinePrefences);
